<template>
  <div>
    <!-- Зөвхөн админ шалгаж байх үед (statusCode 1) -->
    <div v-if="statusCode === 1" class="st-kyc-alert ml-4 mr-4 mt-4 mb-4">
      <i class="sr sr-information"></i>
      <div class="st-kyc-alert-body">
        <h5>{{ $t("helper.verifying-id-card") }}</h5>
      </div>
    </div>
    <!-- Админ татгалзсан үед (statusCode 3) дахин оруулахыг сануулна -->
    <div v-if="statusCode === 3" class="st-kyc-alert ml-4 mr-4 mt-4 mb-4">
      <i class="sr sr-information"></i>
      <div class="st-kyc-alert-body">
        <h5>{{ $t("helper.rejected-id-card") }}</h5>
      </div>
    </div>
    <!-- Зургийн жагсаалт ачаалагдаж дуустал upload форм харагдахгүй -->
    <div v-if="idsLoading" class="d-flex justify-content-center py-5">
      <b-spinner variant="primary" />
    </div>
    <template v-else>
    <div class="row" v-if="ids && hasIds(100)">
      <div v-for="(item, i) in ids.filter((it) => it.type === 100)" class="col">
        <id-card-view
          :img-id="item.id"
          :label="`${$t(getLabel(item.filename))}`"
          :can-reupload="statusCode === 3"
          @emptyIds="emptyIds(100)"
        ></id-card-view>
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <!--          <id-card-view v-if="" :img-id="item.id" :label="`${$t(getLabel(item.filename))}`"></id-card-view>-->
        <image-input
          db-name="ids_front"
          id="front"
          ref="front"
          @return="getFront"
          :label="$t('registration.front')"
        ></image-input>
        <div
          class="text-red-400 text-sm"
          v-show="v$.form.frontPic.$errors.length"
        >
          <div class="text-red" v-show="!v$.form.frontPic.$errors.required">
            {{ $t("helper.front-of-id-card") }}
          </div>
        </div>
      </div>
      <div class="col">
        <image-input
          db-name="ids_back"
          id="back"
          ref="back"
          @return="getBack"
          :label="$t('registration.back')"
        ></image-input>
        <div
          class="text-red-400 text-sm"
          v-show="v$.form.backPic.$errors.length"
        >
          <div class="text-red" v-show="!v$.form.backPic.$errors.required">
            {{ $t("helper.back-of-id-card") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="user.is_disabled && disabilityStatusCode !== 0"
      class="st-kyc-alert ml-4 mr-4 mt-4 mb-4"
    >
      <i class="sr sr-information"></i>
      <div class="st-kyc-alert-body">
        <h5>{{ disabilityStatusString }}</h5>
      </div>
    </div>
    <template v-if="user.is_disabled">
      <div class="row" v-if="ids && hasIds(200)">
        <div
          v-for="(item, i) in ids.filter((it) => it.type === 200)"
          class="col"
        >
          <id-card-view
            :img-id="item.id"
            :label="`${$t(getLabel(item.filename))}`"
            :can-reupload="disabilityStatusCode === 4"
            @emptyIds="emptyIds(200)"
          ></id-card-view>
        </div>
      </div>
      <div v-else class="row mt-4">
        <div class="col">
          <image-input
            db-name="ids_disability_front"
            id="disability_front"
            ref="disability_front"
            @return="getDisabilityFront"
            label="Хөгжлийн бэрхшээлтэй хүний үнэмлэхийн урд хэсэг*"
          ></image-input>
          <div
            class="text-red-400 text-sm"
            v-show="v$.form.disabilityFrontPic.$errors.length"
          >
            <div
              class="text-red"
              v-show="!v$.form.disabilityFrontPic.$errors.required"
            >
              {{ $t("helper.front-of-id-card") }}
            </div>
          </div>
        </div>
        <div class="col">
          <image-input
            db-name="ids_disability_back"
            id="disability_back"
            ref="disability_back"
            @return="getDisabilityBack"
            label="Хөгжлийн бэрхшээлтэй хүний үнэмлэхийн арын хэсэг*"
          ></image-input>
          <div
            class="text-red-400 text-sm"
            v-show="v$.form.disabilityBackPic.$errors.length"
          >
            <div
              class="text-red"
              v-show="!v$.form.disabilityBackPic.$errors.required"
            >
              {{ $t("helper.back-of-id-card") }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="isUploading" class="d-flex justify-content-center mt-xl-5">
      <ic-button
        class="card-button"
        size="tn"
        :loading="loading"
        @click="submit"
        >{{ $t("kyc.confirm.verify") }}
      </ic-button>
    </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DocInput from "./DocInput.vue";
import ImageInput from "../../global/ImageInput/index.vue";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { getUserIds, postUserIDs } from "../../../api/user";
import IdCardView from "../../global/ImageInput/IdCardView.vue";

export default {
  components: { IdCardView, DocInput, ImageInput },
  computed: {
    ...mapState("user", [
      "user",
      "statusCode",
      "statusString",
      "disabilityStatusCode",
      "disabilityStatusString",
    ]),
    // Зураг оруулах форм харагдаж байгаа үед л баталгаажуулах товч харуулна
    isUploading() {
      return !this.hasIds(100) || (this.user.is_disabled && !this.hasIds(200));
    },
  },
  setup() {
    const v$ = useVuelidate();
    return { v$ };
  },
  data() {
    return {
      loading: false,
      idsLoading: true,
      ids: [],
      form: {
        frontPic: null,
        backPic: null,
        disabilityFrontPic: null,
        disabilityBackPic: null,
      },
    };
  },
  validations() {
    const disability = this.user.is_disabled;
    const newIds = !this.hasIds(100);
    const newDisabilityIds = !this.hasIds(200);
    return {
      form: {
        frontPic: { required: requiredIf(newIds) },
        backPic: { required: requiredIf(newIds) },
        disabilityFrontPic: {
          required: requiredIf(disability && newDisabilityIds),
        },
        disabilityBackPic: {
          required: requiredIf(disability && newDisabilityIds),
        },
      },
    };
  },
  mounted() {
    this.getIds();
  },
  methods: {
    async getIds() {
      try {
        const { data } = await getUserIds();
        this.ids = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.idsLoading = false;
      }
    },
    async submit() {
      await this.v$.$validate();
      console.log("v$ error:", this.v$.$error);
      console.log("frontPic:", this.form.frontPic);
      console.log("backPic:", this.form.backPic);
      if (!this.v$.$error) {
        this.loading = true;
        const formData = new FormData();
        if (!this.hasIds(100)) {
          formData.append("ids_front", this.form.frontPic);
          formData.append("ids_back", this.form.backPic);
        }
        if (this.user.is_disabled && !this.hasIds(200)) {
          formData.append("ids_disability_front", this.form.disabilityFrontPic);
          formData.append("ids_disability_back", this.form.disabilityBackPic);
        }
        if ([...formData.entries()].length > 0) {
          try {
            await postUserIDs(formData);
          } catch (e) {
            // Баталгаажсан эсвэл шалгагдаж байгаа зургийг дахин илгээсэн (409) гэх мэт
            const data = e.response?.data;
            this.$bvToast.toast(data?.message || "Алдаа гарлаа", {
              title: "Анхаар",
              variant: e.response?.status === 409 ? "warning" : "danger",
            });
            this.loading = false;
            if (e.response?.status === 409) {
              await this.$store.dispatch("user/fetchUser");
              await this.getIds();
            }
            return;
          }
          await this.$store.dispatch("user/fetchUser");
        }
        this.loading = false;
        this.$emit("selectTab", 4);
      }
      this.loading = false;
    },
    // Зөвхөн татгалзсан төрлийн зургийг арилгаж, дахин оруулах формыг харуулна
    emptyIds(type) {
      this.ids = this.ids.filter((it) => it.type !== type);
    },
    getFront(value) {
      this.form.frontPic = value;
      this.v$.form.frontPic.$model = value;
    },
    getBack(value) {
      this.form.backPic = value;
      this.v$.form.backPic.$model = value;
    },
    getDisabilityFront(value) {
      this.form.disabilityFrontPic = value;
      this.v$.form.disabilityFrontPic.$model = value;
    },
    getDisabilityBack(value) {
      this.form.disabilityBackPic = value;
      this.v$.form.disabilityBackPic.$model = value;
    },
    getLabel(fileName) {
      const labelVal = "registration.";
      let suff = "photo";
      if (fileName.includes("ids_front"))
        suff = this.isChild ? "front-bc" : "front";
      if (fileName.includes("ids_back"))
        suff = this.isChild ? "back-bc" : "back";
      if (fileName.includes("ids_selfie"))
        suff = this.isChild ? "selfie-bc" : "selfie";
      if (fileName.includes("ids_signature")) suff = "signature";
      if (fileName.includes("ids_disability_front")) suff = "disability-front";
      if (fileName.includes("ids_disability_back")) suff = "disability-back";
      return labelVal + suff;
    },
    hasIds(type) {
      return this.ids.some((it) => it.type === type);
    },
  },
};
</script>
<style scoped lang="scss">
.title {
  font-size: 14px;
  font-weight: 500;
}

.st-kyc-alert {
  justify-content: left;
  align-items: flex-start;
  display: flex;
  background-color: var(--warning-color-10);
  border: 1px solid var(--warning-color);
  border-radius: 5px;
  padding: 15px;

  i {
    color: var(--warning-color);
  }
}

.st-kyc-alert-body {
  flex: 1;
  margin-left: 10px;

  h5 {
    font-weight: 700;
    font-size: 12px;
    color: var(--primary-color-new);
    margin-bottom: 0px;
  }

  p {
    margin-top: 0;
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    color: var(--primary-color-new);
  }
}
</style>
